import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { usePagination } from "../../../../hooks/usePagination";
import api from "../../../../util/api";
import {
  CustomerApiType,
  PaginatedResponse,
  QueryKeys,
} from "../../../../util/types";

export const useGetCustomers = (ownerId?: string) => {
  const { page, limit, onPaginationChange, resetPageNum } = usePagination();

  const {
    data,
    isLoading,
    isFetching,
    refetch: refreshCustomers,
  } = useQuery<PaginatedResponse<CustomerApiType>>({
    queryKey: [QueryKeys.LIST_CUSTOMERS, page, limit, ownerId ?? ""],
    queryFn: async () => {
      return await api.getCustomers(page, limit, {}, ownerId);
    },
    placeholderData: (prev) => prev,
  });

  useEffect(() => {
    resetPageNum();
  }, [ownerId]);

  return {
    customers: data?.docs ?? [],
    totalDocs: data?.totalDocs ?? 0,
    loading: isLoading || isFetching,
    refreshCustomers,
    page,
    limit,
    onPaginationChange,
  };
};
